<template>
    <div class='container_wrap'>
        <div class="poster-wrap" v-if="showPoster" @click="closePoster">
            <div class="poster" ref="signInPoster" @click.stop="() => {}">
                <img class="poster-bg" src="@/assets/images/user/talk/background-img.jpg" alt="">
                <div class="qrcodeBox flc" ref="qrcodeBox"></div>
                <div class="address flc">
                    <img src="@/assets/images/user/talk/address-logo.png" alt="">
                    {{templateObj.new_address}}
                </div>
            </div>
            <div class="poster-img" v-show="photo_url" @click.stop="() => {}">
                <img :src="photo_url" alt="" @load="imgOver">
            </div>
            <div class="save-btn flc" v-show="photo_url" @click.stop="() => {}">
                长按保存
                <img :src="photo_url" alt="">
            </div>
        </div>
        <div class="content-wrap">
            <!--            <div class="select-area flc" @click="showSelect('template')">-->
            <!--                {{ templateObj.new_name || '请选择体验间' }}-->
            <!--                <img src="@/assets/images/user/talk/select.png" alt="">-->
            <!--            </div>-->
            <div class="select-area2  flc">
                <div class="select-template" @click="showSelect('template')">
                    {{ templateObj.new_name || '请选择体验间' }}
                    <img src="@/assets/images/user/talk/select.png" alt="">
                </div>
                <div class="showPoster-btn" @click="clickShowPoster">
                    签到二维码
                </div>
            </div>
            <div class="customer-list">
                <div class="title">签到客户记录列表</div>
                <div class="customer-box">
                    <van-list
                        v-model="CustomerLoading"
                        :finished="CustomerFinished"
                        finished-text="没有更多了"
                        @load="touchBottom"
                    >
                        <van-cell :border="false" class="customer-item flc2" v-for="(item,index) in writeOffList"
                                  :key="index" @click="changeCustomer(item.id)">
                            <img :src="item.headimgurl" alt="">
                            <span class="nickname" :class="{'active':selectCustomer == item.id}">{{
                                    item.nickname
                                }}</span>
                            <span :class="{'active':selectCustomer == item.id}">
                                    {{ showTime(item.created_at) }}
                                </span>
                            <div class="border-line"></div>
                            <template #right-icon>
                                <van-icon name="checked" size="20" class="checked-icon"
                                          v-if="selectCustomer == item.id"/>
                                <van-icon name="circle" size="20" class="checked-icon"
                                          v-if="selectCustomer != item.id"/>
                            </template>
                        </van-cell>
                    </van-list>
                </div>
            </div>

            <div class="binding flc2">
                <div class="binding-title">是否有预约</div>
                <div class="btn-list">
                    <div class="btn-item flc" @click="changeBtn(0)" :class="{'active-btn':currentBtn == 0}">有</div>
                    <div class="btn-item flc" @click="changeBtn(1)" :class="{'active-btn':currentBtn == 1}">无</div>
                </div>
            </div>
            <div class="select-customer" v-show="currentBtn == 0" @click="showSelect('customer')"  :class="{'select-Current':reportObj.showInfo }">
                {{ reportObj.showInfo || '预约记录' }}
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>
            <div class="select-customer" v-show="currentBtn == 1" @click="showSelect('time')" :class="{'select-Current':showSelectTimeStr}">
                {{ showSelectTimeStr || '带看时间' }}
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>

            <div class="select-customer" :class="{'select-Current':reportObj.sign_name || signerObj.fullname}"  @click="showSelect('signer')">
                {{ showSinger }}
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>

            <div class="select-customer" :class="{'select-Current':userTypeObj.name}" v-show="currentBtn == 1" @click="showSelect('usertype')">
                <span v-if="userTypeObj.name">客户类型：</span>
                {{userTypeObj.name || '客户类型'}}
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>

            <div class="select-customer" :class="{'select-Current':peopleName.length}" v-show="currentBtn == 1" @click="showSelect('Supporter')">
                <span v-if="peopleName.join(',')">支持人：{{peopleName.join(',')}}</span>
                <span v-else>支持人</span>
                <img src="@/assets/images/user/talk/select.png" alt="">
            </div>



<!--            <div class="select-area2 mtop flc"  v-show="currentBtn == 1">-->
<!--                <div class="select-template" @click="showSelect('Supporter')">-->
<!--                    <span v-if="peopleName.join(',')">支持人:{{peopleName.join(',')}}</span>-->
<!--                    <span v-else>请选择支持人</span>-->
<!--                    <img src="@/assets/images/user/talk/select.png" alt="">-->
<!--                </div>-->
<!--                <div class="userType-btn flc" @click="showSelect('usertype')">-->
<!--                    {{userTypeObj.name || '客户类型'}}-->
<!--                    <img src="@/assets/images/user/talk/select.png" alt="">-->
<!--                </div>-->
<!--            </div>-->

            <div class="appointer" v-show="currentBtn == 0">
                <div class="appoint-info flc2" :class="{'select-Current':reportObj.prospect_name && reportObj.prospect_name.length}">
                    支持人
                    <div class="appoint-info-box" v-if="reportObj.prospect_name && reportObj.prospect_name.length">
                        ：
                        {{ reportObj.prospect_name.join(',') }}
                    </div>
                </div>
                <div class="appoint-info flc2" :class="{'select-Current':reportObj.sign_name}">预约人
<!--                    <span-->
<!--                    v-if="reportObj.user_type == 0 ">(绑定签单手)</span>-->
                    <span v-if="reportObj.sign_name">：{{ reportObj.sign_name }}</span>
                </div>
            </div>


        </div>
        <div class="empty"></div>
        <div class="writeoff flc" :class="{'writeoff-active':showWriteOff}"
             @click="writeOff">
            确认核销
        </div>
        <!--        用户预约列表弹窗-->
        <van-popup round v-model="bSelect" position="bottom" :style="{ height: selectType == 'time'?'70%':'' }">
            <van-list v-if="selectType == 'template' || selectType == 'customer' || selectType == 'signer' || selectType == 'usertype'"
                      v-model="cloading" :finished="cfinished" finished-text="没有更多了" @load="pickerBottom"
                      :immediate-check="false" :offset="100">
                <van-search v-if="selectType == 'template' || selectType == 'signer'" class="searchDiv"
                            right-icon="search" left-icon="" v-model="TSearch"
                            :placeholder="selectType == 'template'?'可搜索列表中没有的体验间':'请输入搜索关键词'"/>
                <van-picker
                    class="picker-select"
                    title="请选择"
                    show-toolbar
                    :columns="columns"
                    @confirm="confirmSelect"
                    :value-key="selectKey"
                    @cancel="bSelect = false"
                />
            </van-list>
            <div v-else-if="selectType == 'time'" class="popup-box-content">
                <div class="popup-btn-list">
                    <div class="flc" @click="cancelTime">取消</div>
                    <div class="flc" @click="confirmTime">确定</div>
                </div>
                <div class="popup-content">
                    <div v-for="(item ,index ) in ReportTimeData2" :key="item.timeTitle">
                        <div class="title">{{ item.timeTitle }}</div>
                        <van-cell class="time-item" v-for="(item2,index2) in item.list" :key="item.start_time"
                                  @click="changeSelectTime(index,index2)">
                            <div style="width:100%;" class="flc" :class="{'active-time':showActiveTime(index,index2)}">
                                {{ item2.start_at }}-{{ item2.end_at }}
                            </div>
                            <div class="border-line"></div>
                            <template #right-icon>
                                <van-icon name="success" size="20" class="success-icon"
                                          v-show="showActiveTime(index,index2)"/>
                            </template>
                        </van-cell>
                    </div>
                </div>
            </div>
        </van-popup>
        <!--        选择支持人员-->
        <van-popup style="height:83%;" @close="closePeopleChoose" v-model="peopleChoose" round position="bottom"
                   class="choosePeople">
            <div class="chooseCell1">
                <span>已选择人员</span>
                <span @click="confirmPeople">确定</span>
            </div>
            <div class="choosePeopelBox" v-if="peopleName.length > 0">
                <div class="item" v-for="(item,index) in peopleName" :key="index">
                    <span>{{ item }}</span>
                    <span @click="deletePeople(item)"><img src="@/assets/images/user/talk/delete.png" alt=""></span>
                </div>
            </div>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getbottom"
                      :immediate-check="false" :offset="100">
                <van-checkbox-group v-model="people">
                    <van-search right-icon="search" left-icon="" v-model="search" placeholder="请输入搜索关键词"/>
                    <div style="padding:0 20px;">
                        <van-cell-group>
                            <van-cell v-for="(item, index) in SupportData" clickable :key="index" :title="item.fullname"
                                      @click="toggle(index)">
                                <template #right-icon>
                                    <van-checkbox checked-color="#318544" :name="item" ref="checkboxes"/>
                                </template>
                            </van-cell>
                        </van-cell-group>
                    </div>
                </van-checkbox-group>
            </van-list>
        </van-popup>
        <toast :isShow="bShowToast" @confirmWriteoff="confirmWriteoff" :userinfoObj="userinfoObj"
               @close="bShowToast = false"></toast>
    </div>
</template>
<script>
import {fetchVerifyAuthForB} from '@/libsV2/havc.js'

import toast from './components/toast'
import QRCode from 'qrcodejs2'
let OSS = require("ali-oss");
import detail from "@/js/detail.js";
import html2canvas from 'html2canvas'
let progressTime = null;

export default {
    name: "",

    // 组件注册
    components: {toast},
    data() {
        return {
            showPoster: false,//显示弹窗海报
            TSearch: '',// 搜索字段
            cloading: false,//用户预约信息
            cfinished: false,//用户预约信息
            bSelectCustomer: false,//用户下拉列表
            loading: false,
            finished: false,
            people: [],
            search: '',
            peopleChoose: false,//支持人选择
            templateObj: {},// 体验间对象
            userinfoObj: {},
            userTypeObj:{},//选择的用户类型
            bShowToast: false,//是否显示核销弹窗
            signerObj: {},// 签单手
            bSelect: false,//显示选择框
            CustomerLoading: false,
            CustomerFinished: false,
            params: {
                page: 0,
                limit: 20
            },
            reportObj: {},//选择的报告信息
            columns: [],
            selectKey: '',//选择弹窗的key
            selectCustomer: -1, //选中需要核销的潜客
            selectObj: {},// 选中的体验间
            currentBtn: -1,//当前活跃按钮
            selectType: '',//选择的弹窗类型  template 体验间 customer 潜客 time时间 Supporter 支持人
            selectTime: [],//选中的时间列表
            selectRealTime: [],// 请求时间列表
            photo_url:'',//生成的海报地址
        };
    },
    props: {},
    //计算属性
    computed: {
        showFlc() {
            if (Object.keys(this.reportObj).length > 0) {
                if (this.reportObj.prospect_name.length < 2) {
                    return true
                } else {
                    return false
                }
            } else {
                return true
            }
        },
        showSinger () {
            if (this.reportObj.showInfo) {
                return `绑定签单手：${this.reportObj.sign_name}`
            } else if (this.signerObj.fullname) {
                return `绑定签单手：${this.signerObj.fullname}`
            } else {
                return '绑定签单手'
            }
        },
        ReportListData() {
            const list = this.$store.state.userTalkAppointV3.ReportListData.filter(item => {
                // return true
                return item.is_sign == 1 || item.is_prospect == 1 || item.is_project == 1
            })
            return list
        },
        requestTime() {
            let date = new Date()
            let year = date.getFullYear()
            let month = date.getMonth() + 1
            let day = date.getDate()
            month = month < 10 ? '0' + month : month
            day = day < 10 ? '0' + day : day

            const dated = Date.parse(new Date())
            //时间搓转化成正常时间
            let oldDate = new Date(dated - 1000 * 24 * 60 * 60);
            const yeared = oldDate.getFullYear();
            let monthed = oldDate.getMonth() + 1
            let dayed = oldDate.getDate()
            monthed = monthed < 10 ? '0' + monthed : monthed
            dayed = dayed < 10 ? '0' + dayed : dayed
            return {
                search_end: `${year}-${month}-${day}`,
                search_start: `${yeared}-${monthed}-${dayed}`
            }
        },
        requestTime2() {
            return {
                search_start: this.requestTime.search_start + ' 00:00:00',
                search_end: this.requestTime.search_end + ' 23:59:59',
            }
        },
        showWriteOff() {
            if (this.currentBtn == 1 && Object.keys(this.templateObj).length > 0 && this.selectRealTime.length > 0 && this.selectCustomer != -1 && this.signerObj.fullname && this.userTypeObj.name) {
                return true
            } else if (this.currentBtn == 0 && Object.keys(this.templateObj).length > 0 && Object.keys(this.reportObj).length > 0 && this.selectCustomer != -1) {
                return true
            } else {
                return false
            }
        },
        // 是否可以选择签单手
        showSelectSinger() {
            if (this.currentBtn == 1 && Object.keys(this.templateObj).length > 0 && this.selectRealTime.length > 0 && this.selectCustomer != -1 ) {
                return true
            } else if (this.currentBtn == 0 && Object.keys(this.templateObj).length > 0 && Object.keys(this.reportObj).length > 0 && this.selectCustomer != -1) {
                return true
            } else {
                return false
            }
        },
        peopleName() {
            const people = this.people
            let peopleList = [];
            people.forEach(person => {
                peopleList.push(person.fullname);
            })
            return peopleList
        },
        // 支持人员
        SupportData() {
            return this.$store.state.userTalkAppointV3.SupportData
        },
        // 选中的预约信息
        SelectList() {
            return this.$store.state.userTalkAppointV3.SelectList
        },
        // 显示选中的时间
        showSelectTimeStr() {
            const nowdated = Date.parse(new Date())
            //时间搓转化成正常时间
            // 获取昨天时间
            let newDate = new Date(nowdated - 1000*60*60*24);
            const yeared = newDate.getFullYear();
            let monthed = newDate.getMonth() + 1;
            let dated = newDate.getDate();
            // 获取今天时间
            const nowdate = new Date()
            const year = nowdate.getFullYear();
            let month = nowdate.getMonth() + 1;
            let date = nowdate.getDate();

            let yearList = [`${year}.${month}.${date} `,`${yeared}.${monthed}.${dated} `]

            let timeStr = ''
            if (this.selectRealTime.length) {
                timeStr = yearList[this.selectRealTime[0].index]
            }
            function compare(property){
                return function(a,b){
                    var value1 = a[property];
                    var value2 = b[property];
                    return   value1 - value2
                }
            }
            let selectRealTime = this.selectRealTime.sort(compare('index2'))
            console.log(selectRealTime,'selectRealTime')
            let boolean = selectRealTime.every( (item,idx) => {
                if (idx == selectRealTime.length -1 ) {
                    return true
                }
                if((selectRealTime[idx].index2 + 1) == selectRealTime[idx+1].index2 ) {
                    return true
                } else {
                    return false
                }
            })
            console.log(boolean,'boolean')
            if (boolean && selectRealTime.length > 0) {
                // timeStr += `${this.ReportTimeData2[0].list[selectRealTime[0].index2].start_at}`
                timeStr += `${this.ReportTimeData2[selectRealTime[0].index].list[selectRealTime[0].index2].start_at}~${this.ReportTimeData2[selectRealTime[selectRealTime.length - 1].index].list[selectRealTime[selectRealTime.length - 1].index2].end_at}`
            } else {
                selectRealTime.forEach((item, idx) => {
                    timeStr += `${this.ReportTimeData2[item.index].list[item.index2].start_at}~${this.ReportTimeData2[item.index].list[item.index2].end_at}`
                    if (idx != selectRealTime.length - 1) {
                        timeStr += ','
                    }
                })
            }
            return timeStr
        },
        // 是否选中
        showActiveTime(index, index2) {
            return (index, index2) => {
                let idx = this.selectTime.findIndex(item => item.index == index && item.index2 == index2)
                return idx != -1
            }
        },
        // 体验间时间段
        ReportTimeData2() {
            return this.$store.state.userTalkAppointV3.ReportTimeData2
        },
        // 处理时间字符串
        showTime(time) {
            return time => {
                let timeList = time.split(" ");
                return `${timeList[0].split('-').join('.')} ${timeList[1].substring(0, 5)}`
            }
        },
        // 获取核销列表
        writeOffList() {
            if (this.templateObj.name) {
                return this.$store.state.userTalkAppointV3.writeOffList
            } else {
                return []
            }
        },
        // 体验间
        TemplateRoomData() {
            return this.$store.state.userTalkAppointV3.TemplateRoomData
        },
    },
    // 数据监听
    watch: {
        TSearch: {
            handler(newText, oldText) {
                this.finished = false
                this.$set(this.params, 'page', 0)
                const searchText = newText.trim();
                if (this.selectType == 'template') {
                    this.$store.dispatch({
                        type: 'userTalkAppointV3/getTemplateRoomData', ...this.params,
                        search: searchText
                    }).then(() => {
                        this.columns = this.TemplateRoomData
                    })
                } else if (this.selectType == 'signer') {
                    this.$store.dispatch({
                        type: 'userTalkAppointV3/getSupportData3', ...this.params,
                        search: searchText
                    }).then(() => {
                        this.columns = this.SupportData
                    })
                }
            }
        },
        search: {
            // 支持人员搜索
            handler(newText, oldText) {
                // 如果新老值只有空格上的区别就不触发
                this.finished = false
                const searchText = newText.trim();
                Promise.all([
                    this.$store.dispatch({
                        type: 'userTalkAppointV3/getSupportData2', ...this.params,
                        search: searchText
                    })
                ]).then(() => {
                    // 因为搜索的时候需要切换渲染出来的数组，
                    // 但是如果直接切换，那么已选择的不会被选中。这个时候就需要循环已经被选中的人员，在新的数组中选中他，
                    //  从而实现修改了所有的人员，已被选中的还是处于被选的状态
                    const people = this.people
                    let newPeople = []
                    people.forEach(person => {
                        const obj = this.SupportData.find(item => {
                            return item.systemuserid == person.systemuserid
                        })
                        if (obj == undefined) {
                            newPeople.push(person)
                        } else {
                            newPeople.push(obj)
                        }
                    })
                    this.people = newPeople
                })
            },
            deep: true,
        },
        currentBtn() {
            this.reportObj = {}
        },
        bSelect() {
            this.TSearch = ''
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$emit('writeoff')
            vm.$store.commit('userTalkAppointV3/SavewriteOffList', [])
            console.log(vm.writeOffList,'writeOffListwriteOffListwriteOffList')
        })
    },
    //方法集合
    methods: {
        // 图片加载完成
        imgOver () {
            this.$store.commit("loadSwitch", false);
        },
        // 关闭弹窗海报
        closePoster () {
            this.showPoster = false
            // 清除二维码
            this.$refs.qrcodeBox.innerHTML = ''
        },
        // 获取oss配置
        async getOssSts(sUrl) {
            let oOssData = await detail.getOsssts({
                ext: "png",
            });
            let oOss = oOssData.result;
            //  console.log("加密数据", oOssData);
            let sKey = `tbzIwry9lT0qU81m${oOss.timestamp}`;
            // let oOssDecrypt = this.decrypt(sKey, oOss.body);
            // console.log('需要上传的图片',sUrl)
            let oFile = await this.base64ToLife(sUrl, oOss.key);
            this.ossUploadImg(oOss, oFile);
        },

        getShareImg(id) {
            let that = this;
            that.$store.commit("loadSwitch", true);
            detail.getShareImg({ nId: id }).then((res) => {
                let img = new Image();
                let image_url = res.result.image_url;
                // img.onload = () => {
                //     that.objImg = image_url;
                //     this.$toast({
                //         message:'您可长按保存图片'
                //     })
                // };
                // img.src = image_url;
                this.photo_url = image_url
                console.log(this.photo_url, 'url');
                //  console.log("图片路径", res.result.image_url);
            });
        },

        async savePoster(sFileName) {
            let oData = {
                image_url: sFileName,
            };
            let oSavePoster = await detail.getPoster(oData);
            let nPosterId = oSavePoster.result;
            //  console.log(nPosterId);
            // debugger
            // this.nRate = 100;
            clearInterval(progressTime);
            setTimeout(() => {
                //  console.log(nPosterId);
                // wx.miniProgram.redirectTo({
                //     url: `/pages/case/poster/index?nId=${nPosterId}`
                // });
                // this.$router.push({ path: `/antshare/index?nId=${nPosterId}` });
                this.getShareImg(nPosterId)
            }, 1000);
        },
        // 上传图片到oss
        async ossUploadImg(oOss, oFile) {
            let client = new OSS({
                region: oOss.sts.region,
                bucket: oOss.sts.bucket,
                accessKeyId: oOss.sts.access_key_id,
                accessKeySecret: oOss.sts.access_key_secret,
                endpoint: oOss.sts.endpoint_internal,
                stsToken: oOss.sts.security_token,
                //cname: true,
                // timeout:30,
                secure: true,
            });
            try {
                //  console.log(oOss.object_name, oFile);
                client
                    .multipartUpload(oOss.object_name, oFile)
                    .then((res) => {
                        console.log(res);
                        let sFileName = res.name;
                        this.savePoster(oOss.filename); //保存海报
                    })
                    .catch((err) => {
                        console.log("错误信息", err);
                    });
            } catch (e) {
                //  console.log(e);
            }
        },
        // base64 转 Blod
        base64ToLife(dataurl, filename) {
            return new Promise((resolve, reject) => {
                const arr = dataurl.split(",");
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                let blod = new Blob([u8arr], { type: mime });
                // blod.lastModifiedDate = new Date();
                // blod.name = filename;
                resolve(blod);
            });
        },
        // 点击展示海报
        clickShowPoster() {
            if (Object.keys(this.templateObj).length > 0) {
                this.showPoster = true
                this.$nextTick(() => {
                    this.crateQrcode()
                    this.$nextTick(() => {
                        this.htmlToImage()
                    })
                })
            } else {
                this.$toast('请先选择体验间')
            }
        },
        // 生成海报
        htmlToImage() {
            // console.log('父')
            let that = this;
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            let sHeight = 604;
            let sWidth = 312;
            this.$store.commit("loadSwitch", true);
            html2canvas(that.$refs.signInPoster, {
                useCORS: true,
                backgroundColor: null,
                dpi: 72,
            })
                .then((canvas) => {
                    let sUrl = canvas.toDataURL("image/png", 1);
                    this.getOssSts(sUrl);
                    // console.log(sUrl,'surl');
                    console.log('成功');
                })
                .catch((fail) => {
                    console.log('失败');
                    this.$store.commit("loadSwitch", false);
                    console.log(fail);
                });
        },
        crateQrcode() {
            this.$common.pushEvent('sign_wind_project', this.templateObj.new_srv_projectmgnid)
            var qrcode = new QRCode(this.$refs.qrcodeBox, {
                text: `${window.location.href.split('writeoff')[0]}scanning?project_id=${this.templateObj.new_srv_projectmgnid}&track_action=sign_wind_project&track_id=${this.templateObj.new_srv_projectmgnid}&track_uuid=${sessionStorage.getItem('page_uuid')}`,
                width: 100,
                height: 100,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.L
            });
            // console.log(this.qrcode)
        },
        // 选择框触底
        pickerBottom() {
            this.$set(this.params, 'page', this.params.page + 1)
            if (this.selectType == 'customer') {
                let length = this.SelectList.length
                this.$store.dispatch({
                    type: 'userTalkAppointV3/getSelectList', ...this.params,
                    state: 3, ...this.requestTime,
                    search_type: -1
                }).then(() => {
                    this.cloading = false
                    if (length == this.SelectList.length) {
                        this.cfinished = true
                    }
                })
            } else if (this.selectType == 'template') {
                let length = this.TemplateRoomData.length
                this.$store.dispatch({type: 'userTalkAppointV3/getTemplateRoomData', ...this.params}).then(() => {
                    this.cloading = false
                    if (length == this.TemplateRoomData.length) {
                        this.cfinished = true
                    }
                    this.columns = this.TemplateRoomData
                })
            }
        },
        // 确认核销
        confirmWriteoff() {
            if (this.currentBtn == 0) {
                // 如果是已预约
                console.log(this.reportObj, 'reportObj')
                this.$store.dispatch({
                    type: 'userTalkAppointV3/writeOff',
                    report_id: this.reportObj.id,
                    sign_id: this.selectCustomer
                }).then(() => {
                    this.$toast('核销成功')
                    this.bShowToast = false
                    // 跳转
                    this.$router.push('/hvac/talk/v3/myappoint')
                    // 重新获取数据
                    // this.$store.commit('userTalkAppointV3/SavewriteOffList',[])
                    // 清空选中的体验信息
                    // this.reportObj = {}
                    // this.$store.dispatch({
                    //     type: 'userTalkAppointV3/writeOffList', ...this.params,
                    //     experience_id: this.templateObj.new_srv_projectmgnid
                    // })
                })
            } else {
                let list = []
                this.selectRealTime.forEach(item => {
                    console.log(item.index, 'index')
                    list.push({
                        start_at: this.ReportTimeData2[item.index].list[item.index2].start_at,
                        end_at: this.ReportTimeData2[item.index].list[item.index2].end_at,
                    })
                })

                let prospects_ids = []
                this.people.forEach(item => {
                    prospects_ids.push(item.systemuserid)
                })
                let obj = this.writeOffList.find(item => item.id == this.selectCustomer)
                // 如果是未预约
                let options = {
                    experience_id: this.templateObj.new_srv_projectmgnid,
                    items: JSON.stringify(list),
                    sign_id: this.selectCustomer,
                    sign_uid: this.signerObj.systemuserid,
                    user_type: this.userTypeObj.id, // 默认给一个身份
                    prospects_ids: prospects_ids.join(','),
                    user_name: obj.nickname
                }
                this.$store.dispatch({
                    type: 'userTalkAppointV3/writeOff2',
                    ...options
                }).then(() => {
                    this.$toast('核销成功')
                    this.bShowToast = false
                    // 跳转
                    this.$router.push('/hvac/talk/v3/myappoint')
                })
            }

        },
        // 删除人员选择
        deletePeople(name) {
            const index = this.SupportData.findIndex(item => item.fullname == name)
            this.$refs.checkboxes[index].toggle();
        },
        // 关弹窗
        closePeopleChoose() {
            this.peopleChoose = false
        },
        // 选择人员
        toggle(index) {
            this.$refs.checkboxes[index].toggle();
        },
        // 确定选择人员
        confirmPeople() {
            this.peopleChoose = false
        },
        // 触底刷新
        getbottom() {
            this.$set(this.params, 'page', this.params.page + 1)
            let length = this.SupportData.length
            this.$store.dispatch({type: 'userTalkAppointV3/getSupportData', ...this.params}).then(() => {
                this.loading = false;
                if (this.SupportData.length == length && length != 0) {
                    this.finished = true
                }
            })
        },
        // 取消选择时间
        cancelTime() {
            this.bSelect = false
            this.selectTime = this.selectRealTime
        },
        // 确定选择时间
        confirmTime() {
            this.bSelect = false
            this.selectRealTime = this.selectTime
            console.log(this.selectTime,'selecttime')
        },
        // 点击选择时间
        changeSelectTime(index, index2) {
            let idx = this.selectTime.findIndex(item => item.index == index && item.index2 == index2)
            if (idx == -1) {
                if (!this.selectTime[0] || this.selectTime[0].index == index) {
                    this.selectTime.push({
                        index, index2
                    })
                } else {
                    this.$toast('只能选择同一天的的时间段')
                }
            } else {
                this.$delete(this.selectTime, idx)
            }
        },
        // 确定选择
        confirmSelect(selected) {
            console.log(selected, 'selected')
            if (!selected) {
                this.bSelect = false
                return
            }
            switch (this.selectType) {
                case 'template':
                    this.templateObj = selected
                    // 清空列表 以及请求参数
                    this.params = {
                        page: 0,
                        limit: 20
                    }
                    this.$store.commit('userTalkAppointV3/SavewriteOffList', [])
                    this.$store.dispatch({
                        type: 'userTalkAppointV3/writeOffList', ...this.params,
                        start:this.requestTime.search_start,
                        end:this.requestTime.search_end,
                        experience_id: selected.new_srv_projectmgnid
                    })
                    this.bSelect = false
                    break;
                case 'customer':
                    this.reportObj = selected
                    this.bSelect = false
                    break;
                case 'signer':
                    this.bSelect = false
                    this.signerObj = selected
                    break;
                case 'usertype':
                    this.bSelect = false
                    this.userTypeObj = selected
                    break;
            }
        },
        // 点击核销
        writeOff() {
            if (this.showWriteOff) {
                if (this.currentBtn == 0) {
                    // 如果是已预约
                    let obj = this.writeOffList.find(item => item.id == this.selectCustomer)
                    let list = this.reportObj.sub.reverse()
                    this.userinfoObj = {
                        name: obj.nickname,
                        day: `${this.reportObj.mark_date.split('-')[0]}年${this.reportObj.mark_date.split('-')[1]}月${this.reportObj.mark_date.split('-')[2]}日`,
                        time: list
                    }
                    this.bShowToast = true
                } else {
                    // 如果是未预约
                    let obj = this.writeOffList.find(item => item.id == this.selectCustomer)
                    let timeList = []
                    let list = this.selectRealTime

                    function compare(property, property2) {
                        return function (a, b) {
                            var value1 = a[property];
                            var value11 = a[property2];
                            var value2 = b[property];
                            var value22 = b[property2];
                            if (value1 == value2) {
                                return value11 - value22
                            }
                            return value1 - value2
                        }
                    }

                    list = list.sort(compare('index', 'index2'))
                    list = list.forEach(item => {
                        timeList.push({
                            time: this.ReportTimeData2[item.index].list[item.index2].start_at + '~' + this.ReportTimeData2[item.index].list[item.index2].end_at
                        })
                    })
                    let day
                    // 判断选中的时间是第一天的还是第二天的
                    if (this.selectRealTime[0].index == 0) {
                        day = this.requestTime.search_end
                    } else {
                        day = this.requestTime.search_start
                    }
                    this.userinfoObj = {
                        name: obj.nickname,
                        day: `${day.split('-')[0]}年${day.split('-')[1]}月${day.split('-')[2]}日`,
                        time: timeList
                    }
                    this.bShowToast = true
                }
            }
        },
        // 点击显示选择弹窗
        showSelect(type) {
            this.$set(this.params, 'page', 0)
            // template 体验间 customer 潜客 time时间 Supporter 支持人
            this.selectType = type
            switch (type) {
                case 'template':
                    this.selectKey = 'new_name'
                    // 清空体验间数据
                    this.$store.commit('userTalkAppointV3/SaveTemplateRoomData', [])
                    this.$store.dispatch({type: 'userTalkAppointV3/getTemplateRoomData', ...this.params}).then(() => {
                        this.columns = this.TemplateRoomData
                        this.bSelect = true
                    })
                    break;
                case 'customer':
                    if (!this.templateObj.new_name) {
                        this.$toast('请选择体验间')
                    } else if (this.selectCustomer == -1) {
                        this.$toast('请选择需要核销的微信用户')
                    } else if (this.templateObj.new_name) {
                        this.$store.commit('userTalkAppointV3/SaveSelectList', [])
                        this.$store.dispatch({
                            type: 'userTalkAppointV3/getSelectList',
                            project_id: this.templateObj.new_srv_projectmgnid, ...this.params,
                            state: 3, ...this.requestTime2,
                            search_type: -1
                        }).then(() => {
                            this.columns = this.SelectList
                            console.log(this.SelectList,'SelectList')
                            this.selectKey = 'showInfo'
                            this.bSelect = true
                        })
                    } else {
                        this.$toast('请选择体验间')
                    }
                    break;
                case 'time':
                    if (!this.templateObj.new_name) {
                        this.$toast('请选择体验间')
                    } else if (this.selectCustomer == -1) {
                        this.$toast('请选择需要核销的微信用户')
                    } else {
                        this.$store.dispatch({
                            type: 'userTalkAppointV3/getReportTimeData2',
                            experience_id: this.templateObj.new_srv_projectmgnid
                        }).then(() => {
                            this.bSelect = true
                        })
                    }
                    break;
                case 'Supporter':
                    if (this.SupportData.length == 0) {
                        this.$store.dispatch({
                            type: 'userTalkAppointV3/getSupportData2', ...this.params,
                            search: this.search
                        })
                    }
                    this.peopleChoose = true
                    break;
                case 'signer':
                    // 如果没选择体验间
                    if (Object.keys(this.templateObj).length == 0) {
                        this.$toast('请选择体验间')
                        return
                    }
                    // currentBtn 0 已预约 1 未预约
                    if (this.currentBtn == 1) {
                        // 如果没选择预约时间
                        // 如果没选择支持人员
                        // 如果没选择需要核销的微信用户
                        // 如果全部都选了，让用户选择绑定签单手
                        if (Object.keys(this.templateObj).length == 0) {
                            this.$toast('请选择体验间')
                            return
                        } else if (this.selectRealTime.length == 0) {
                            this.$toast('请选择带看时间')
                            return
                        }
                            // else if ( this.selectCustomer == -1 ) {
                            //     this.$toast('请选择需要核销的微信用户')
                            //     return
                        // }
                        else {
                            this.selectKey = 'fullname'
                            this.$store.dispatch({type: 'userTalkAppointV3/getSupportData', ...this.params}).then(() => {
                                this.columns = this.SupportData
                                this.bSelect = true
                            })
                        }
                    } else if (this.currentBtn == 0) {
                        // 已预约
                        // 如果没有选择需要核销的预约时间
                        // 如果没有选择需要核销的微信用户
                        // 如果选择的预约类型是已录入的潜客，
                        // 如果全部选择了
                        if (Object.keys(this.reportObj).length == 0) {
                            this.$toast('请选择预约时间')
                            return
                        }
                            // else if ( this.selectCustomer == -1 ) {
                            //     this.$toast('请选择需要核销的微信用户')
                            //     return
                        // }
                        else if (this.reportObj.user_type == 0) {
                            this.$toast('签单手已绑定，无法修改')
                        } else {
                            this.selectKey = 'fullname'
                            this.$store.dispatch({type: 'userTalkAppointV3/getSupportData', ...this.params}).then(() => {
                                this.columns = this.SupportData
                                this.bSelect = true
                            })
                        }
                    } else {
                        this.$toast('请选择预约类型')
                    }
                    break;
                case 'usertype':
                    this.columns = [
                        { name: '潜客(未录入)', id:4 },
                        { name: '设计师', id: 1 },
                        { name: '设计师(未录入)', id:5},
                        { name: '异业', id: 2 },
                        { name: '其他', id: 3 },
                    ]
                    this.selectKey = 'name'
                    this.bSelect = true
                    break;
            }
        },
        // 切换按钮
        changeBtn(index) {
            this.currentBtn = index
        },
        changeCustomer(id) {
            if (this.selectCustomer == id) {
                this.selectCustomer = -1
            } else {
                this.selectCustomer = id
            }
        },
        touchBottom() {
            // if (!this.templateObj.name){
            //     this.CustomerLoading = false
            //     return
            // }
            this.$set(this.params, 'page', this.params.page + 1)
            let length = this.writeOffList.length
            this.$store.dispatch({type: 'userTalkAppointV3/writeOffList', ...this.params,start:this.requestTime.search_start, end:this.requestTime.search_end}).then(res => {
                this.CustomerLoading = false
                if (this.writeOffList.length == length) {
                    this.CustomerFinished = true
                }
            })
        }
    },
    //生命周期 - 创建完成
    created() {
        fetchVerifyAuthForB(() => {
            this.$store.dispatch({type: 'userTalkAppointV3/getCustomerData', page: 0, limit: 10})
            let project_id = this.$route.query.project_id
            this.$set(this.params, 'page', 0)
            // 如果带有这个体验间id，说明是扫码进来的，这个时候需要自动带出体验见
            if (project_id) {
                this.$store.dispatch({
                    type: 'userTalkAppointV3/getTemplateRoomData', ...this.params,
                    id: project_id
                }).then(() => {
                    console.log(this.TemplateRoomData, 'TemplateRoomData')
                    this.templateObj = this.TemplateRoomData.find(item => item.new_srv_projectmgnid == project_id)
                    this.$store.dispatch({
                        type: 'userTalkAppointV3/writeOffList', ...this.params,
                        start:this.requestTime.search_start,
                        end:this.requestTime.search_end,
                        experience_id: this.templateObj.new_srv_projectmgnid
                    })
                })
            }
        })
    },
    //生命周期 - 挂载完成
    mounted() {
    },
    // 页面离开触发
    beforeRouteLeave(to, from, next) {
        this.$store.commit('userTalkAppointV3/SavewriteOffList', [])
        next()
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.container_wrap {
    width: 100%;
    height: 100%;

    .poster-wrap {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0;
        z-index: 10;
        top: 0;
        background-color: rgba(0, 0, 0, 0.5);
        .poster-img {
            width: 600px;
            height: 848px;
            margin: 200px auto 0;
        }
        .save-btn {
            width: 600px;
            height: 80px;
            border-radius: 12px;
            margin: 50px auto;
            background-color:#318544;
            color:#fff;
            position:relative;
            img {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                z-index: 10;
                opacity: 0;
                height: 100%;
            }
        }
        .poster {
            position: absolute;
            left: 200vw;
            top: 200vw;
            //left: 50%;
            //top: 50%;
            //transform: translate(-50%, -50%);
            //background-image: url('~@/assets/images/user/talk/writeoff-bg.png');
            //background-size: 100% 100%;
            width: 600px;
            height: 848px;
            .poster-bg {
                width: 600px;
                height: 848px;
                position:absolute;
                left:0;
                top: 0;
                z-index:-1;
            }
            .qrcodeBox {
                width: 270px;
                height: 320px;
                margin: 300px auto 0;
                z-index:10;
            }

            .address {
                width: 90%;
                margin: 70px auto;
                text-align: center;
                font-size: 35px;
                font-weight: normal;
                z-index:10;
                color: #EDD3A8;

                img {
                    width: 30px;
                    margin-right: 20px;
                }
            }
        }
    }

    .content-wrap {
        margin: 20px 32px;
        //min-height: 1064px;
        box-sizing: border-box;
        //overflow: auto;
        background-color: #fff;
        border-radius: 16px;
        padding: 32px 24px;
        display: flex;
        flex-direction: column;

        .select-area2 {
            width: 100%;

            .showPoster-btn {
                width: 160px;
                padding: 20px 0;
                text-align: center;
                border-radius: 12px;
                background: #318544;
                margin-left: 20px;
                color: #fff;
                position: relative;

                .tips {
                    color: rgba(0, 0, 0, .5);
                    position: absolute;
                    bottom: -30px;
                    left: 10px;
                }
            }
            .userType-btn {
                width: 200px;
                height: 82px;
                text-align: center;
                border-radius: 12px;
                padding-right: 20px;
                margin-left: 20px;
                border: #DBDBDB 1px solid;
                position: relative;
                img {
                    position: absolute;
                    width: 32px;
                    height: 32px;
                    right: 8px;
                    top: 50%;
                    transform: translateY(-50%);

                }
            }
            .select-template {
                flex: 1;
                padding: 20px;
                position: relative;
                font-size: 28px;
                text-align: center;
                border-radius: 12px;
                border: 2px solid #DBDBDB;

                img {
                    position: absolute;
                    width: 32px;
                    height: 32px;
                    right: 16px;
                    top: 24px;
                }
            }
        }

        .select-area {
            width: 100%;
            padding: 20px;
            margin-top: 20px;
            border-radius: 12px;
            border: 2px solid #DBDBDB;
            position: relative;
            font-size: 28px;
            font-weight: 400;
            color: #444444;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: flex;

            img {
                position: absolute;
                width: 32px;
                height: 32px;
                right: 16px;
                top: 24px;
            }
        }

        .appointer {
            width: 100%;

            .appoint-info {
                margin: 20px 0;
                height: 80px;
                color: #7B7B7B;
                background: #F7F7F7;
                font-size: 28px;
                border-radius: 12px;
                padding-left: 28px;

                .appoint-info-box {

                }
            }

        }

        .select-customer {
            margin-top: 24px;
            width: 100%;
            padding: 20px 40px 20px 24px;
            border-radius: 12px;
            border: 2px solid #DBDBDB;
            position: relative;
            font-size: 28px;
            font-weight: 400;
            color: #7B7B7B;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;

            img {
                position: absolute;
                width: 32px;
                height: 32px;
                right: 16px;
                top: 24px;
            }
        }



        .customer-list {
            display: flex;
            overflow: auto;
            flex-direction: column;

            .title {
                margin-top: 40px;
                font-size: 28px;
                font-weight: 400;
                color: #313131;
            }

            .checked-icon {
                color: #318444;
            }

            .customer-box {
                //flex: 1;
                width: 100%;
                height: 324px;
                margin-top: 10px;
                overflow: auto;

                .customer-item {
                    position: relative;

                    img {
                        width: 68px;
                        height: 68px;
                        border-radius: 50%;
                    }

                    .nickname {
                        display: inline-block;
                        width: 220px;
                        height: 48px;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }

                    .border-line {
                        position: absolute;
                        bottom: -20px;
                        left: 0;
                        width: 100%;
                        height: 5px;
                        background-image: url('~@/assets/images/user/talk/border-line.png');
                        background-size: 100% 100%;
                    }
                }
            }
        }

        .binding {
            margin-top: 24px;
            height: 80px;

            .binding-title {
                font-size: 28px;
                font-weight: 400;
                color: #313131;
                width: 150px;
            }

            .select-singer {
                color: #7B7B7B;
            }

            .btn-list {
                flex: 1;
                //margin-top: 24px;
                display: grid;
                grid-template-columns: 1fr 1fr;
                column-gap: 24px;
                height: 80px;

                .btn-item {
                    height: 80px;
                    border: 2px solid #318544;
                    border-radius: 8px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #318544;
                }

                .active-btn {
                    background: #318544;
                    color: #FFFFFF;
                }
            }

            .binding-info {
                flex: 1;
                height: 80px;
                border-radius: 12px;
                border: 2px solid #DBDBDB;
                padding-left: 20px;
                font-size: 28px;
                font-weight: 400;
                color: #7B7B7B;
                position: relative;

                img {
                    position: absolute;
                    width: 32px;
                    height: 32px;
                    right: 16px;
                    top: 24px;
                }

            }
        }
    }

    .empty {
        width: 100%;
        height: 200px;
    }

    .writeoff {
        position: fixed;
        left: 50%;
        transform: translate(-50%, -50%);
        bottom: 50px;
        width: 638px;
        height: 100px;
        background: #DDDDDD;
        border-radius: 12px;
        font-size: 32px;
        font-weight: 400;
        color: #6B6B6B;
    }

    .writeoff-active {
        color: #FFFFFF;
        background: linear-gradient(136deg, #4EA062 0%, #338444 100%);
    }
}

::v-deep .van-cell {
    padding: 20px 0;
}

::v-deep .van-cell__value {
    display: flex;
    align-items: center;
    transition: all 0.4s;

    span {
        font-size: 28px;
        font-weight: 400;
        color: #575757;
        margin: 0 16px;
    }

    .active {
        color: #318544;
    }
}

::v-deep .van-picker__confirm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    background: #318544;
    color: #FFFFFF;
    margin: 0 10px;
    border-radius: 8px;
}

::v-deep .van-picker__cancel {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    border-radius: 8px;
    border: 2px solid #318544;
    color: #318544;
    margin: 0 10px;
}

.popup-btn-list {
    border-radius: 15px;
    z-index: 99999;
    position: absolute;
    padding: 10px 32px;
    left: 0;
    top: 8px;
    background-color: #FFFFFF;
    width: 100%;
    height: 80px;
    display: flex;
    justify-content: space-between;

    div:nth-child(1) {
        width: 170px;
        height: 68px;
        border-radius: 8px;
        border: 2px solid #318544;
        font-size: 28px;
        font-weight: 400;
        color: #318544;
    }

    div:nth-child(2) {
        width: 170px;
        height: 68px;
        background: #318544;
        border-radius: 8px;
        font-size: 28px;
        font-weight: 400;
        color: #FFFFFF;
    }
}

.popup-content {
    height: calc(70vh - 80px);
    padding-bottom: env(safe-area-inset-bottom);
    overflow: auto;

    .title {
        font-size: 32px;
        font-weight: 400;
        color: #313131;
        margin-left: 32px;
    }
}

.popup-box-content {
    padding-top: 100px;
}

.time-item {
    font-size: 28px;
    font-weight: 400;
    color: #A1A1A1;
}

.active-time {
    color: #318544;
}

.success-icon {
    color: #318544;
    position: absolute;
    right: 32px;
}


// 选择用户下拉框
::v-deep .van-field__body {
    width: 100%;
}

.choosePeople {
    .chooseCell1 {
        width: 100%;
        padding: 32px 20px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        span:nth-child(1) {
            height: 44px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #444444;
        }

        span:nth-child(2) {
            width: 120px;
            height: 60px;
            background: #318544;
            border-radius: 8px;
            text-align: center;
            line-height: 60px;
            font-size: 28px;
            font-weight: 400;
            color: #ffffff;
        }
    }

    .choosePeopelBox {
        width: 100%;
        padding: 0px 20px;
        display: flex;
        flex-wrap: wrap;

        .item {
            margin-top: 28px;
            margin-right: 40px;
            width: 200px;
            height: 68px;
            background: rgba(49, 133, 68, 0.1);
            border-radius: 6px;
            display: flex;
            align-items: center;

            &:nth-child(3n) {
                margin-right: 0;
            }

            span:nth-child(1) {
                text-align: center;
                flex: 1;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #318544;
                line-height: 40px;
            }

            span:nth-child(2) {
                width: 40px;
                height: 40px;
                margin-right: 20px;

                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }
}
.select-Current {
    font-size: 32px !important;
    font-weight: 400 !important;
    color: #313131 !important;
}
.mtop {
    margin-top: 24px;
}
.van-icon {
    display: flex;
    justify-content: center;
    align-items: center;
}

::v-deep .van-icon-search {
    margin-right: 10px;
}
</style>
